/* @flow */
/*jshint esversion: 6 */
import React, { Component } from "react";
import "../../App.css";
import { Button, Card, Tooltip, Icon, Modal, Pagination } from "antd";
import KdsBonItem from "./KdsBonItem";
import KdsBonPrevOrders from "./KdsBonPrevOrders";

type Props = {
    kdsData: Object,
    noDataText: String,
    sendAPI: Function,
    setJson: Function,
    data: Object,
    height: Number,
}

class KdsBonimView extends Component {
    constructor(props: Props) {
        super(props);
        this.state = {
            modalOwner: null,
            pageNum: 1,
        };

        this.loop1 = null;
        this.counterRefresh = 0;

        this.id = "KDS_BONIM_VIEW";

        this.api = {
            get: "get_kds_bonim_view",
        }

        this.selectors = [
            { id: 'BONIM_TAGS', api: 'get_tags_from_type_2' },
        ];

        if (props.data[this.id] === undefined) props.data[this.id] = { data: [] };

        this.selectors.forEach(x => {
            if (props.data[x.id] === undefined) props.data[x.id] = { dataset: [] };
        });

    }

    componentDidMount() {
        this.getDataApi();
        this.loopRefresh();

        this.props.sendAPI(this.selectors[0].api, '', (obj) => {
            let dataset = obj.data ? obj.data.split('\r').map(x => {
                let y = x.split('\f');
                return { code: y[0], name: y[1] }
            }) : []

            this.props.setJson(this.id, { dataset });
        });
    }

    componentWillUnmount() {
        clearTimeout(this.loop1);
    }

    loopRefresh = () => {
        this.setState({ lastRender: new Date() }, () => {
            let refreshTime = parseInt(this.props.kdsData.sRefreshTime);

            this.counterRefresh++;

            if (refreshTime <= this.counterRefresh) {
                this.getDataApi();
                this.counterRefresh = 0;
            }

            this.loop1 = setTimeout(this.loopRefresh, 1000);
        })
    }


    getDataApi = () => {
        // 
        this.props.sendAPI(this.api.get, '_id\r' + this.props.kdsData.sID, (obj) => {
            let data = []
            if (obj.data) {
                let dataRes = obj.data.split('\r').map(x => {
                    let y = x.split('\f');
                    return {
                        oID: y[0],
                        oNumber: y[1],
                        id: y[2],
                        itemCode: y[3],
                        itemName: y[4],
                        qty: y[5],
                        readyStatus: y[6],
                        title: y[7],
                        group: y[8],
                        groupTitle: y[9],
                        orderTime: y[10],
                        orderMethod: y[11],
                        orderRemarks: y[12],
                        remarks: y[13],

                        oTimeStart: y[14],
                        oTimeEnd: y[15],
                        oSupplierLogo: y[16],
                        oCustName: y[17],
                        oParentId: y[18]
                    }
                });



                dataRes.forEach(x => {
                    let bonReadyStatus = {}
                    let isFireBonus = false
                    if (x.readyStatus == 2) {
                        bonReadyStatus = { _finish: true }
                    } else if (!parseInt(x.readyStatus)) {
                        bonReadyStatus = { _notFinish: true }
                    } else if ([1, 3].find(f => f == x.readyStatus)) {
                        isFireBonus = true
                    }
                    let oIndex = data.findIndex(f => f.oID === x.oID)
                  
                    if (oIndex > -1) {
                        data[oIndex] = {
                            ...data[oIndex],
                            ...bonReadyStatus,
                            _countFireBons: data[oIndex]._countFireBons + (isFireBonus?1:0),
                            oBonData: [...data[oIndex].oBonData, x]
                        }
                    } else {
                        data.push({
                            oID: x.oID,
                            oNumber: x.oNumber,
                            orderTime: x.orderTime,
                            orderMethod: x.orderMethod,
                            orderRemarks: x.orderRemarks,
                            oTimeStart: x.oTimeStart,
                            oTimeEnd: x.oTimeEnd,
                            oSupplierLogo: x.oSupplierLogo,
                            oCustName: x.oCustName,
                            oBonData: [x],
                            ...bonReadyStatus,
                            _countFireBons: isFireBonus?1:0
                        })

                    }
                })
            }

            this.props.setJson(this.id, { data });

            let x = this.state.modalOwner ? data.find(f => f.oID === this.state.modalOwner.owner.oID) : null;
            if (x) {
                let tagData = this.props.data[this.selectors[0].id].dataset.find(f => f.code === this.props.kdsData.sItemTagId);
                // let color = (x._finish && x._notFinish) ? 'yellow' : (x._finish && !x._notFinish) ? 'lawngreen' : (!x._finish && x._notFinish) ? 'pink' : ''
                let color = this.getColor(x);
                let modalOwner = {
                    owner: {
                        oID: x.oID,
                        oNumber: x.oNumber,
                        orderTime: x.orderTime,
                        orderMethod: x.orderMethod,
                        orderRemarks: x.orderRemarks,
                        oTimeStart: x.oTimeStart,
                        oTimeEnd: x.oTimeEnd,
                        oSupplierLogo: x.oSupplierLogo,
                        oCustName: x.oCustName,
                        _finishBons: x._finish ? ['1']: [],
                        _notFinishBons: x._notFinish ? ['1']: [],
                        _countFireBons: x._countFireBons,
                        oMethodsDesc: x.orderMethod
                    },
                    bon: { ...tagData, color },
                    bonData: x.oBonData
                }
                this.setState({ modalOwner })
            }
        });

    }

    getColor = (x) => {
        console.log("_countFireBons - f", x)

        let color = '#DEEBF7'//'lawngreen';
        if (!this.props.isShort) {
            if (x._finish && !x._notFinish) color = '#E2F0D9'//'yellow';
            if (!x._finish && x._notFinish) color = '#FFF2CC'// 'pink';
        }
        return color;
    }

    render() {

        // let cardWidth = this.props.height / 2;
        let cardWidth = (window.innerWidth / (this.props.kdsData.sCountRows ?? 4) ) - 20;

        const divStyle = {
            height: this.props.height,
            overflowY: 'auto',
        }

        let tagData = this.props.data[this.selectors[0].id].dataset.find(f => f.code === this.props.kdsData.sItemTagId);

        
        const { data } = this.props.data[this.id]
        let pageSize = (this.props.kdsData.sCountRows ?? 4) 
        let fromIndex = pageSize * (this.state.pageNum - 1)
        let toIndex = pageSize * this.state.pageNum
        let dataFilter = data.length > pageSize ? data.slice(fromIndex, toIndex) : data

        return (<>
            {data.length > 8 ?
                <div style={{ textAlign: "center", direction: "ltr" }}>
                    <Pagination
                        current={this.state.pageNum}
                        total={data.length}
                        pageSize={(this.props.kdsData.sCountRows ?? 4)}
                        onChange={p => { this.setState({ pageNum: p }) }}
                    />
                </div> : ""}
                <div style={divStyle}>
            {/* {this.props.isShort ? (<KdsBonPrevOrders {...this.props}  handleChange={this.getDataApi} />) : ""} */}
            {dataFilter.length ?
                dataFilter.map(x => {
                    // let color = (x._finish && x._notFinish) ? 'yellow' : (x._finish && !x._notFinish) ? 'lawngreen' : (!x._finish && x._notFinish) ? 'pink' : '';
                    let color = this.getColor(x);

                    let dataProps = {
                        owner: {
                            oID: x.oID,
                            oNumber: x.oNumber,
                            orderTime: x.orderTime,
                            orderMethod: x.orderMethod,
                            orderRemarks: x.orderRemarks,
                            _finishBons: x._finish ? ['1'] : [],
                            _notFinishBons: x._notFinish ? ['1']: [],
                            _countFireBons: x._countFireBons,
                            oTimeStart: x.oTimeStart,
                            oTimeEnd: x.oTimeEnd,
                            oSupplierLogo: x.oSupplierLogo,
                            oCustName: x.oCustName,
                            oMethodsDesc: x.orderMethod
                        },
                        bon: { ...tagData, color },
                        bonData: x.oBonData
                    }
                    return (<KdsBonItem
                        {...this.props}
                        {...dataProps}
                        cardWidth={this.props.isShort ? 600 : window.innerWidth > 600 ? cardWidth : window.innerWidth * 0.9}
                        onClick={[1, 2].find(f => f == this.props.kdsData.sZoomEnable) && !this.props.isShort ?
                            () => { this.setState({ modalOwner: dataProps }) }
                            : this.props.kdsData.sZoomEnable == 3 ? null
                                : () => { }
                        }
                        getDataApi={this.getDataApi}
                        handleChange={this.getDataApi}
                    />)
                })
                :
                (<div style={{ height: cardWidth }}>
                    {this.props.getText(15878)}
                </div>)}
            {this.state.modalOwner ? (
                <KdsBonItem
                    {...this.props}
                    {...this.state.modalOwner}
                    isModalZoom
                    cardWidth={window.innerWidth / 2.5}
                    handleChange={this.getDataApi}
                    closeModal={() => { this.setState({ modalOwner: false }) }}
                    getDataApi={this.getDataApi}
                />
            ) : ''}


        </div>
        </>)
    }
}

export default KdsBonimView;